{
  "name": "stemx",
  "version": "0.1.4895-dev",
  "license": "MIT",
  "scripts": {
    "update-ds-rules": "yarn ts-node --transpile-only --compiler-options '{\"module\":\"CommonJS\",\"moduleResolution\":\"node\"}' scripts/update-ds-rules.ts",
    "serve": "node --max_old_space_size=8192 node_modules/@angular/cli/bin/ng serve",
    "serve-dev": "yarn conf dev && yarn serve --proxy-config proxy.conf.dev.js",
    "serve-dev-local": "yarn conf dev && yarn serve --proxy-config proxy.conf.dev-local.js",
    "serve-prodlike": "yarn conf prodlike && yarn serve --proxy-config proxy.conf.prodlike.js --host local-admin.stx.interticket.com --disable-host-check",
    "serve-prod": "yarn conf prod && yarn serve --proxy-config proxy.conf.prod.js --host local-admin.stx.interticket.com --disable-host-check",
    "serve-ext": "yarn conf ext && yarn serve --proxy-config proxy.conf.ext.js",
    "serve-ext2": "yarn conf ext2 && yarn serve --proxy-config proxy.conf.ext2.js",
    "serve-local": "yarn conf local && yarn serve",
    "serve-gateway": "yarn conf qa && node --max_old_space_size=8192 node_modules/@angular/cli/bin/ng serve --proxy-config proxy.conf.gateway.js",
    "serve-mock": "yarn conf mock && yarn serve --configuration=mock --proxy-config proxy.conf.qa.js",
    "serve-mock-dev": "yarn conf mock && yarn serve --configuration=mock --proxy-config proxy.conf.dev.js",
    "serve-mock-ext": "yarn conf mock && yarn serve --configuration=mock --proxy-config proxy.conf.ext.js",
    "set-version": "yarn version --no-git-tag-version --new-version",
    "build": "node --max_old_space_size=8192 node_modules/@angular/cli/bin/ng build",
    "build-dev": "yarn build",
    "build-prod": "yarn build --configuration=production",
    "lint": "node scripts/lint.mjs",
    "lint-fix": "node scripts/lint.mjs --fix",
    "lint-scss": "stylelint --config stylelint.config.mjs --cache --cache-location node_modules/.cache/stylelint/ \"**/*.scss\"",
    "lint-html": "htmlhint \"**/*.html\" --config node_modules/@interticket/eslint-config-angular/.htmlhintrc",
    "conf": "yarn ts-node -P ./src/environments/tsconfig.env.json ./src/environments/app-config/gen-app-configs.ts",
    "upit": "yarn add @interticket/core @interticket/eslint-config-angular",
    "find-deadcode": "ts-prune | grep -v \"stories.ts\\|mock.ts\\|index.ts\"",
    "bundle-report:build": "yarn build-prod --stats-json && yarn bundle-report:view",
    "bundle-report:view": "esbuild-visualizer --metadata dist/stats.json --filename dist/bundle-report.html",
    "sb:ui-kit": "yarn conf mock && ng run stemx:storybook-ui-kit",
    "sb:ui-kit:build": "yarn conf mock && ng run stemx:build-storybook-ui-kit",
    "sb:ui-kit:publish": "yarn sb:ui-kit:build && yarn chromatic --storybook-build-dir=dist/storybook/ui-kit --project-token=84a74b6e80d4",
    "sb:itds": "yarn conf mock && ng run stemx:storybook-itds",
    "sb:itds:fresh": "git stash && git fetch && git rebase origin/qa && git stash pop; yarn && rm -rf node_modules/.cache/storybook && yarn sb:itds",
    "sb:itds:build": "yarn conf mock && ng run stemx:build-storybook-itds",
    "sb:itds:publish": "yarn sb:itds:build && yarn chromatic --storybook-build-dir=dist/storybook/itds --project-token=chpt_48bdedc04e1f0b8",
    "publish:storybook": "yarn sb:ui-kit:publish && yarn sb:itds:publish",
    "chromatic": "node scripts/chromatic.mjs --auto-accept-changes --only-changed --exit-zero-on-changes --no-interactive --skip-update-check --zip",
    "knip": "knip",
    "test": "ng test",
    "test:ci": "ng test --watch=false",
    "test:headless": "yarn test:ci && yarn test:browser",
    "test:coverage": "ng test --watch=false --coverage",
    "test:browser": "ng test --configuration=browser --watch=false",
    "check:cycles": "node tools/check-import-cycles.mjs",
    "smoke:routes": "node tools/route-smoke.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.20",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.20",
    "@angular/compiler": "^21.2.20",
    "@angular/core": "^21.2.20",
    "@angular/fire": "20.0.1",
    "@angular/forms": "^21.2.20",
    "@angular/google-maps": "^21.2.0",
    "@angular/material": "^21.2.14",
    "@angular/platform-browser": "^21.2.20",
    "@angular/platform-browser-dynamic": "^21.2.20",
    "@angular/router": "^21.2.20",
    "@ckeditor/ckeditor5-angular": "^7.0.0",
    "@danielmoncada/angular-datetime-picker": "^21.0.0",
    "@interticket/ckeditor5": "43.0.47",
    "@interticket/core": "^21.0.25",
    "@interticket/core-ts": "0.0.4",
    "@interticket/customer-facing-ui-kit": "21.0.15",
    "@interticket/editor-ui-kit": "^21.0.0",
    "@interticket/html-builder-angular": "^21.0.0",
    "@interticket/microfrontends": "21.0.3",
    "@interticket/public-survey-angular": "^21.0.1",
    "@interticket/seating-chart-angular": "^21.0.24",
    "@interticket/template-layout-editor-angular": "^21.0.5",
    "@stripe/terminal-js": "^0.26.0",
    "angular-calendar": "0.32.2",
    "angular-draggable-droppable": "^9.0.1",
    "angular-feather": "^6.5.1",
    "angular-mixed-cdk-drag-drop": "^2.6.0",
    "angular-resizable-element": "^8.0.0",
    "angularx-qrcode": "^21.0.5",
    "bezier-easing": "^2.1.0",
    "chart.js": "^4.5.0",
    "chartjs-plugin-datalabels": "^2.2.0",
    "file-saver": "^2.0.5",
    "foundation-sites": "^6.9.0",
    "hammerjs": "^2.0.8",
    "heic2any": "^0.0.4",
    "jsprintmanager": "^8.0.0",
    "jwt-decode": "^4.0.0",
    "luxon": "^3.7.1",
    "modern-screenshot": "^4.7.0",
    "ng-gallery": "^12.0.0",
    "ng2-charts": "^8.0.0",
    "ngx-autosize": "^2.0.4",
    "ngx-color-picker": "^20.1.1",
    "ngx-image-cropper": "^9.1.5",
    "ngx-mask": "~21.0.0",
    "ngx-permissions": "^19.0.0",
    "ngx-scrollbar": "19.1.5",
    "ngx-sse-client": "21.0.0",
    "ngx-toastr": "20.0.5",
    "normalize.css": "^8.0.1",
    "pdfmake": "0.3.11",
    "print-js": "^1.6.0",
    "prntr": "^2.0.6",
    "rxjs": "^7.8.1",
    "socket.io-client": "^4.8.1",
    "sourcemapped-stacktrace": "^1.1.11",
    "stackdriver-errors-js": "^0.12.0",
    "swiper": "8.4.2",
    "tslib": "^2.6.3",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "^2.8.0",
    "@angular-builders/custom-esbuild": "^21.1.0",
    "@angular-eslint/builder": "21.4.0",
    "@angular-eslint/eslint-plugin": "21.4.0",
    "@angular-eslint/eslint-plugin-template": "21.4.0",
    "@angular-eslint/schematics": "21.4.0",
    "@angular-eslint/template-parser": "21.4.0",
    "@angular/build": "^21.2.21",
    "@angular/cli": "^21.2.21",
    "@angular/compiler-cli": "^21.2.20",
    "@interticket/eslint-config-angular": "^21.0.0",
    "@storybook/addon-a11y": "10.6.1",
    "@storybook/addon-docs": "10.6.1",
    "@storybook/addon-links": "10.6.1",
    "@storybook/angular-vite": "10.6.1",
    "@stylistic/eslint-plugin": "^5.2.0",
    "@types/file-saver": "^2.0.5",
    "@types/jasmine": "^5.1.8",
    "@types/jsprintmanager": "^3.0.0",
    "@types/luxon": "^3.6.2",
    "@types/node": "^24",
    "@types/pdfmake": "0.3.3",
    "@types/react": "^18.2.0",
    "@typescript-eslint/eslint-plugin": "^8.37.0",
    "@typescript-eslint/parser": "^8.37.0",
    "@vitest/browser-playwright": "4.1.11",
    "ckeditor5": "^42.0.2",
    "esbuild-visualizer": "^0.7.0",
    "eslint": "^9.39.0",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jsdoc": "^51.4.1",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-prefer-arrow-functions": "^3.6.2",
    "eslint-plugin-simple-import-sort": "^12.1.1",
    "eslint-plugin-storybook": "^9.1.6",
    "eslint-plugin-unused-imports": "^4.1.4",
    "glob": "^7.2.3",
    "htmlhint": "^1.1.4",
    "http-proxy-middleware": "^2.0.1",
    "jsdom": "^30.0.1",
    "knip": "^5.42.0",
    "playwright": "^1.63.0",
    "postcss": "^8.5.6",
    "react": "18.2.0",
    "react-dom": "18.2.0",
    "slugify": "^1.6.6",
    "storybook": "10.6.1",
    "stylelint": "^16.22.0",
    "ts-node": "^10.9.1",
    "ts-prune": "^0.10.1",
    "typescript": "~5.9.3",
    "vite": "^8.2.4",
    "vitest": "^4.0.8"
  },
  "engines": {
    "node": "24.19.0",
    "npm": "11.17.0",
    "yarn": "1.22.19"
  },
  "engineStrict": true
}
